import React, { useState } from 'react';
import { ReactComponent as AndroidSvg } from './assets/android.svg';
import { ReactComponent as AppleSvg } from './assets/apple.svg';
import { ReactComponent as LoaderSvg } from './assets/sync.svg';
import { ReactComponent as LogoutSvg } from './assets/poweroff.svg';

export const TopLeft = () => {

    const [isAndroid, setIsAndroid] = useState(false);
    const [isIos, setIsIos] = useState(false);

    const handleMouseAndroid = (isAndroid) => {
        setIsAndroid(isAndroid);
    }
    const handleMouseIos = (isIos) => {
        setIsIos(isIos);
    }

    return (
    <div style={{ display: 'flex', flexDirection: 'row', width: '320px', alignItems: 'center', paddingLeft: 8 }}>
        <img src={require('./assets/logo.png')} width={'72px'} alt='VOTEism' />
        <h1 style={{ color: '#002868', marginLeft: 0, fontSize: '1.6em'}}>
        VOTE<div style={{ display: 'contents', color: '#db282f' }}>ism</div>
        </h1>
        <a href='https://ios.voteism.org/' target='_blank' rel="noopener noreferrer"
        style={{ display: 'flex', marginLeft: 12, cursor: 'pointer' }}>
            <AppleSvg width={30} fill={isIos ? '#8B8AB0' : '#D3D5DD'}
            onMouseEnter={() => handleMouseIos(true)}
            onMouseLeave={() => handleMouseIos(false)} />
        </a>
        <a href='https://android.voteism.org/' target='_blank' rel="noopener noreferrer"
        style={{ display: 'flex', marginLeft: 12, cursor: 'pointer' }}>
            <AndroidSvg width={32} fill={isAndroid ? '#8B8AB0' : '#D3D5DD'}
            onMouseEnter={() => handleMouseAndroid(true)}
            onMouseLeave={() => handleMouseAndroid(false)} />
        </a>
    </div>
    );
}

export const TopRightTable = () => (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingRight: 20 }}>
        {/* <a href='https://docs.voteism.org/transparency' target='_blank' rel="noopener noreferrer"
            style={{ color: '#db282f', fontSize: 16, paddingRight: 8, textDecoration: 'none' }}>
            Transparency
        </a>
        <a href='https://android.voteism.org/' target='_blank' style={{ padding: 8 }}
        rel="noopener noreferrer">
            <img src={require('./assets/androidlogo.png')} width={'40px'} alt='Android App' />
        </a>
        <a href='https://ios.voteism.org/' target='_blank' rel="noopener noreferrer">
            <img src={require('./assets/ioslogo.png')} width={'40px'} alt='ios App' />
        </a> */}
    </div>
);

export const TopRightAnalysis = ({ isIndia, updatedTime, votes, isMpMla, onRefresh }) => {
    
    
    const [isHover, setIsHover] = useState(false);
    const [isLogout, setIsLogout] = useState(false);

    let time = '', mlaVotes = '', mpVotes = '';
    if(updatedTime) {
        time = new Date(updatedTime).toString();
        let index = time.lastIndexOf(':');
        time = 'Updated: '+time.substring(0, index);
        if(votes) {
            let { mp, mla } = isMpMla;
            if(mla) {
                mlaVotes = 'MLA Votes: '+votes.mla+'\n';
            }
            if(mp) {
                mpVotes = 'MP Votes: '+votes.mp;
            }
        }
    }
    const handleMouse = (isHover) => {
        setIsHover(isHover);
    }
    const handleMouseLogout = (isLogout) => {
        setIsLogout(isLogout);
    }
    const logout = () => {
        localStorage.clear();
        window.location.href='https://api.voteism.org/user/logout'
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingRight: 20 }}>
            <h1 style={{ color: '#8B8AB0', fontSize: 14, minWidth: 200, whiteSpace: 'pre', textAlign: 'end' }}>
            {mlaVotes}{mpVotes}{'\n'}{time}
            </h1>
            <div style={{ display: 'flex', marginLeft: 12, cursor: 'pointer' }} onClick={()=>{onRefresh()}}>
                <LoaderSvg width={32} fill={isHover ? '#8B8AB0' : '#D3D5DD'}
                onMouseEnter={() => handleMouse(true)}
                onMouseLeave={() => handleMouse(false)} />
            </div>
            {/* <div style={{ display: 'flex', marginLeft: 12, cursor: 'pointer' }}
            onClick={()=>{ logout() }}>
                <LogoutSvg width={32} height={32} fill={isLogout ? '#8B8AB0' : '#D3D5DD'}
                onMouseEnter={() => handleMouseLogout(true)}
                onMouseLeave={() => handleMouseLogout(false)} />
            </div> */}
        </div>
    );
}